import {ContainerProps as MUIContainerProps, default as MUIContainer} from '@material-ui/core/Container'
import {SidePanel as GWCSidePanel} from '@yandex-taxi/go-web-components'

export * from './alert'
export * from './badge'
export * from './box'
export * from './button'
export * from './card'
export * from './carousel'
export * from './datepicker'
export * from './drawer'
export * from './header'
export {default as useMediaQuery} from './hooks/useMediaQuery'
export * from './input'
export * from './layout'
export * from './list'
export * from './loader'
export * from './locale'
export * from './paper'
export * from './passport-user'
export * from './popover'
export * from './radio'
export * from './section'
export * from './typography'

/** @deprecated */
export const SidePanel = GWCSidePanel
/** @deprecated */
export const Container = MUIContainer
/** @deprecated */
export type ContainerProps = MUIContainerProps
